import { makeStyles } from '@mui/styles';
import CustomTable from 'apollo-react/components/CustomTable';
import TableBody from 'apollo-react/components/TableBody';
import TableCell from 'apollo-react/components/TableCell';
import TableHead from 'apollo-react/components/TableHead';
import TableRow from 'apollo-react/components/TableRow';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import DndRow from './DndRow';

const useStyles = makeStyles({
  thead: {
    fontSize: 14,
  },
  fixedWidth: {
    width: 40,
  },
});

const columns = [
  {
    header: '#',
    accessor: 'rowNumber',
    fixedWidth: true,
  },
  {
    header: '',
    accessor: 'dragIcon',
    fixedWidth: true,
  },
  {
    header: 'Document Number',
    accessor: 'DBP_DOCUMENT_NO',
  },
  {
    header: 'Document Revision',
    accessor: 'DBP_DOCUMENT_REV',
  },
  {
    header: 'Title',
    accessor: 'DBP_DOC_TITLE',
  },
  {
    header: 'Type',
    accessor: 'DBP_DOC_TYPE',
  },
  {
    header: 'Effective Date',
    accessor: 'DBP_DOC_EFFECTIVE_DATE',
  },
  {
    header: '',
    accessor: 'moveTo',
  },
];

const SortPrintOrderTable = ({ rows, setRows }) => {
  const classes = useStyles();

  return (
    <DndProvider backend={HTML5Backend}>
      <CustomTable>
        <TableHead className={classes.thead}>
          <TableRow>
            {columns.map(({ header, accessor, fixedWidth }) => (
              <TableCell
                key={accessor}
                className={
                  fixedWidth &&
                  (accessor !== 'dragIcon' || (accessor === 'dragIcon' && rows.length > 1))
                    ? classes.fixedWidth
                    : null
                }
                variant="head"
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <DndRow key={row.key} rows={rows} columns={columns} index={i} setRows={setRows} />
          ))}
        </TableBody>
      </CustomTable>
    </DndProvider>
  );
};

export default SortPrintOrderTable;
